module.exports = __webpack_public_path__ + "img/logo.8658a6e9.svg";